import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyHead } from './applyHead';
import { buildHead } from './head';
import { resolveSeoPage } from './pages';
import { trackPageView } from '@/lib/metrika';

// Синхронизирует <head> с текущим маршрутом. Пререндер уже положил те же теги
// в HTML, на первом рендере это no-op, при SPA-переходах переписывает
// title/description/canonical/OG/robots/JSON-LD и шлёт просмотр в Метрику.
export default function RouteSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = resolveSeoPage(pathname);
    applyHead(buildHead(page));
    trackPageView(pathname, page.title);
  }, [pathname]);

  return null;
}
